import React from "react";
import { motion } from "framer-motion";
import { Home, Wallet, Zap } from "lucide-react";

export default function ValueProp({ content }) {
  const items = [
    {
      icon: Home,
      title: "Direct Owner Listings",
      desc: "No more chasing dead-end leads. Every listing is a real owner — verified, fresh, and ready to talk.",
    },
    {
      icon: Wallet,
      title: "Pay Per Contact",
      desc: `Just ${content.price_basic} or ${content.price_premium} to unlock an owner contact. No subscriptions, no commitments — only pay for what you use.`,
    },
    {
      icon: Zap,
      title: "Fresh Every Week",
      desc: "New owner listings flow in weekly. Get the early advantage — close faster than the rest of the market.",
    },
  ];

  return (
    <section id="value" className="section relative">
      <div className="container-z">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <div className="label-mono mb-3">Why Brokers Choose Zumroo</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1A231E]">
            Built to help you{" "}
            <span className="text-[#C86646]">close more deals</span>, faster.
          </h2>
        </motion.div>

        <div className="mt-10 sm:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="zcard p-7"
                data-testid={`value-card-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#FBEFE9] border border-[#F2D9CC] flex items-center justify-center text-[#C86646] mb-5">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="text-xl font-bold text-[#1A231E] mb-2">{item.title}</h3>
                <p className="text-sm text-[#5C6B62] leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
